import { Col, Form, Input, Row, Select } from 'antd';

function GraphForm({ children: ButtonSection, handleModalSubmit = () => {}, formData = {}, formDisabled = false, isLoading = false }) {
	const [form] = Form.useForm();

	if (formData) {
		form.setFieldsValue({ ...formData?.result });
	}

	const graphType = [
		{ label: 'Special Box', value: 'specialBox' },
		{ label: 'Line', value: 'line' },
		{ label: 'Bar', value: 'bar' },
		{ label: 'Pie', value: 'pie' },
		{ label: 'Doughnut', value: 'doughnut' },
		{ label: 'Radar', value: 'radar' },
		{ label: 'Polar Area', value: 'polarArea' },
		{ label: 'Bubble', value: 'bubble' },
		{ label: 'Scatter', value: 'scatter' },
	];

	return (
		<Form
			form={form}
			id="coe-graph"
			layout="vertical"
			onFinish={handleModalSubmit}
			autoComplete="off"
			requiredMark={false}
			disabled={formDisabled}
			style={isLoading ? { opacity: 0.5 } : {}}
		>
			<Row gutter={[16, 0]}>
				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						name="graphName"
						label="Graph Name"
						rules={[
							{
								required: true,
								message: 'Please enter graph name',
							},
						]}
					>
						<Input placeholder="Enter graph name" />
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						name="graphDescription"
						label="Graph Description"
						rules={[
							{
								required: true,
								message: 'Please select graph description',
							},
						]}
					>
						<Input placeholder="Enter graph description" />
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						name="graphType"
						label="Graph Type"
						rules={[
							{
								required: true,
								message: 'Please select graph type',
							},
						]}
					>
						<Select options={graphType} placeholder="Select graph type" />
					</Form.Item>
				</Col>
				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						name="graphQuery"
						label="Graph Query"
						rules={[
							{
								required: true,
								message: 'Please enter graph name',
							},
						]}
					>
						<Input placeholder="Enter graph name" />
					</Form.Item>
				</Col>

				{ButtonSection && (
					<Col xs={24} sm={24} md={24} xl={24} style={{ textAlign: 'right' }}>
						{ButtonSection}
					</Col>
				)}
			</Row>
		</Form>
	);
}

export default GraphForm;
